module.exports = __webpack_public_path__ + "static/media/img126.d93386e5.jpg";